'use strict';

function isArrayIndex(n) {
  return n >>> 0 == n && n != 0xFFFFFFFF;
}

module.exports = isArrayIndex;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/isArrayIndex.js
// module id = 139
// module chunks = 1